import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'cs',
  months: [
    'leden',
    'únor',
    'březen',
    'duben',
    'květen',
    'červen',
    'červenec',
    'srpen',
    'září',
    'říjen',
    'listopad',
    'prosinec',
  ],
  monthsShort: ['led', 'úno', 'bře', 'dub', 'kvě', 'čvn', 'čvc', 'srp', 'zář', 'říj', 'lis', 'pro'],
  weekdays: ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota'],
  weekdaysMin: ['N', 'P', 'Ú', 'S', 'Č', 'P', 'S'],
  weekdaysShort: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D.M.YYYY',
    LL: 'D. MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM YYYY HH:mm',
    'LLL-Y': 'D. MMMM HH:mm',
    LLLL: 'dddd D. MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd D. MMMM HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M',
    ll: 'D. MMM YYYY',
    'll-Y': 'D. MMM',
    lll: 'D. MMM YYYY h:mm A',
    'lll-Y': 'D. MMM h:mm A',
    llll: 'ddd D. MMM YYYY h:mm A',
    'llll-Y': 'ddd D. MMM h:mm A',
    'll-Y+w': 'ddd D. M.',
    'LT+to': 'H:mm ([GMT]Z)',
    'LLL+to': 'D. MMMM YYYY H:mm ([GMT]Z)',
  },
  meridiem: { am: 'dop.', pm: 'odp.', AM: 'dop.', PM: 'odp.' },
  past: {
    y: { one: 'před %s r.', few: 'před %s r.', many: 'před %s r.', other: 'před %s l.' },
    M: { one: 'před %s měs.', few: 'před %s měs.', many: 'před %s měs.', other: 'před %s měs.' },
    w: { one: 'před %s týd.', few: 'před %s týd.', many: 'před %s týd.', other: 'před %s týd.' },
    d: { one: 'před %s dnem', few: 'před %s dny', many: 'před %s dne', other: 'před %s dny' },
    h: { one: 'před %s h', few: 'před %s h', many: 'před %s h', other: 'před %s h' },
    m: { one: 'před %s min', few: 'před %s min', many: 'před %s min', other: 'před %s min' },
    s: { one: 'před %s s', few: 'před %s s', many: 'před %s s', other: 'před %s s' },
  },
  future: {
    y: { one: 'za %s r.', few: 'za %s r.', many: 'za %s r.', other: 'za %s l.' },
    M: { one: 'za %s měs.', few: 'za %s měs.', many: 'za %s měs.', other: 'za %s měs.' },
    w: { one: 'za %s týd.', few: 'za %s týd.', many: 'za %s týd.', other: 'za %s týd.' },
    d: { one: 'za %s den', few: 'za %s dny', many: 'za %s dne', other: 'za %s dní' },
    h: { one: 'za %s h', few: 'za %s h', many: 'za %s h', other: 'za %s h' },
    m: { one: 'za %s min', few: 'za %s min', many: 'za %s min', other: 'za %s min' },
    s: { one: 'za %s s', few: 'za %s s', many: 'za %s s', other: 'za %s s' },
  },
  abbr: {
    y: { one: '%s rok', few: '%s roky', many: '%s roku', other: '%s let' },
    M: { one: '%s měs.', few: '%s měs.', many: '%s měs.', other: '%s měs.' },
    w: { one: '%s týd.', few: '%s týd.', many: '%s týd.', other: '%s týd.' },
    d: { one: '%s den', few: '%s dny', many: '%s dne', other: '%s dnů' },
    h: { one: '%s h', few: '%s h', many: '%s h', other: '%s h' },
    m: { one: '%s min', few: '%s min', many: '%s min', other: '%s min' },
    s: { one: '%s s', few: '%s s', many: '%s s', other: '%s s' },
  },
  justNow: 'právě teď',
  yesterday: 'Včera',
  today: 'Dnes',
  tomorrow: 'Zítra',
  weekStart: 1,
};
const localeName: LocaleName = 'cs';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'dop.' : 'dop.';
    } else {
      return isLowerCase ? 'odp.' : 'odp.';
    }
  },
};
